import { SortDescriptor } from "react-aria-components";

import { AiIntegrationView } from "../useSearchAiIntegrations/gql";

export const sortIntegrations = (
  integrations: AiIntegrationView[],
  sortDescriptor: SortDescriptor
): AiIntegrationView[] => {
  const { column, direction } = sortDescriptor;

  return [...integrations].sort((a, b) => {
    let compareValue = 0;

    switch (column) {
      case "name":
        compareValue = a.name.localeCompare(b.name);
        break;
      case "provider":
        compareValue = a.provider.localeCompare(b.provider);
        break;
      case "model":
        compareValue = a.model.localeCompare(b.model);
        break;
      case "space":
        compareValue = (a.space?.name ?? "").localeCompare(b.space?.name ?? "");
        break;
      case undefined:
      default:
        return 0;
    }

    return direction === "ascending" ? compareValue : -compareValue;
  });
};
